import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { Table } from 'react-bootstrap'

import { SignupWithExternalsRecord } from 'internal-components/src/records'

import Signup from './Signup'

export default function SignupList({ pushPath, signups }) {
  return (
    <div className="signup-list">
      <Table hover>
        <thead>
          <tr>
            <th>Service</th>
            <th>Address</th>
            <th>Status</th>
            <th>Reference</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          {signups
            .map(data => (
              <Signup
                key={data.signup.get('id')}
                pushPath={pushPath}
                signupWithExternals={data}
              />
            ))
            .toIndexedSeq()}
        </tbody>
      </Table>
    </div>
  )
}

SignupList.propTypes = {
  pushPath: Pt.func.isRequired,
  signups: Ipt.orderedSetOf(SignupWithExternalsRecord).isRequired,
}



// WEBPACK FOOTER //
// ./src/components/SignupList/index.jsx